import { Link } from 'react-router-dom';

export default function HomeHero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20soft%20gradient%20of%20warm%20cream%20and%20dusty%20rose%20tones%2C%20delicate%20floating%20illustration%20panels%20with%20subtle%20line%20art%20inspired%20by%20Korean%20manhwa%20aesthetics%2C%20ethereal%20atmospheric%20background%20with%20dreamy%20soft%20focus%2C%20elegant%20minimalist%20composition%2C%20gentle%20watercolor%20texture%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20design&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫网站 - 在线韩国漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-8 border border-background-50/20">
            <i className="ri-sparkling-line text-amber-300 text-sm"></i>
            <span className="text-xs text-background-100 font-medium whitespace-nowrap">每日更新 · 海量韩漫 · 免费阅读</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight mb-6 tracking-tight">
            发现你的
            <span className="text-primary-300"> 下一部</span>
            <br />
            心动韩漫
          </h1>

          <p className="text-base md:text-lg text-background-200 max-w-xl mx-auto mb-10 leading-relaxed">
            精选海量韩国漫画，从恋爱甜宠到热血战斗，从悬疑推理到奇幻冒险 —— 随时随地，畅享阅读乐趣
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-background-100 text-sm font-medium hover:text-primary-300 transition-colors underline underline-offset-4 whitespace-nowrap cursor-pointer"
            >
              了解更多关于我们
            </Link>
          </div>

          <div className="mt-16 flex items-center justify-center gap-8 md:gap-12">
            {[
              { num: '5000+', label: '漫画资源' },
              { num: '每日更新', label: '热门连载' },
              { num: '98%', label: '好评率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.num}</p>
                <p className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}